import axios from 'axios'


let baseUrl = 'https://shop-cps.mambike.com/apis/'  // 正式环境
let testUrl = 'https://test-shop-cps.mambike.com/apis/'  // 代理访问测试环境真实路径

// 本地环境
baseUrl = process.env.NODE_ENV === 'development' ? window.location.origin : baseUrl  // 本地代理跨域
// 测试环境
if (process.env.NODE_ENV === 'test') baseUrl = testUrl



// 创建axios实例
const service = axios.create({
  // baseURL: baseUrl,
  baseURL: baseUrl,
  timeout: 20000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // console.log('请求拦截器config, config.token', config)
    
    // let contentType = "application/x-www-form-urlencoded";
  
    // contentType = 'application/json;charset=UTF-8'; // post

    // config.headers['Content-Type'] = contentType
    return config
  },
  error => {
    // Do something with request error
    // console.log('请求拦截error', error) // for debug
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    // console.log('响应拦截res', response.data.code)
    return Promise.resolve(response)
  },
  error => {
    console.log('响应拦截error', error) // for debug
    return Promise.reject(error)
  }
)

export default service
